import moment from 'moment-timezone';

export default (timestamp, timezone = 'UTC', format = 'YYYY/MM/DD HH:mm:ss') => {
    return moment.unix(timestamp).tz(timezone).format(format);
};
